import { UseLoadingReturn } from "@/hooks/use-loading";
import serviceQueueService from "@/services/service-queue.service";
import { RemoveByIdProps } from "@/types/requests.types";

import useRemove from "../../use-remove";

export type Return = {
  remove: (props: RemoveByIdProps) => Promise<void>;
} & UseLoadingReturn;

const useRemoveServiceQueue = (): Return => {
  const response = useRemove({
    operation: (serviceQueueId) => serviceQueueService.delete(serviceQueueId),
  });

  const { isLoading, startLoading, endLoading, loadingIcon, remove } = response;

  return { isLoading, startLoading, endLoading, loadingIcon, remove };
};

export default useRemoveServiceQueue;
